import { flow } from 'lodash';
import { takeLatest, put, select, delay, call, take } from 'redux-saga/effects';

import postApiSlipService from '@giro/shared-services/pdv/postApiSlip.service';

import toaster from '@giro/shared-store/toaster';

import currentStore from '.';

import auth from '@giro/shared-store/auth';

import segmentNormalizeConstant from '@giro-pdv/constants/segmentNormalize.constant';
import dialogSendSlip from '../dialogs/dialogSendSlip';

function* handleServicePost(action) {
  const { payload } = action;

  const sendPayload = {
    app: `${payload.app}_BOLETO`,
    descricao: payload.descricao,
    pagador: {
      nome: payload.pagadorNome,
      documento: payload.pagadorDocumento,
      email: payload.pagadorEmail,
      endereco: {
        endereco: payload.pagadorEndereco,
        estado: payload.pagadorEstado,
        bairro: payload.pagadorBairro,
        cep: payload.pagadorCEP,
        cidade: payload.pagadorCidade,
        telefone: payload.pagadorTelefone,
      },
    },
    referencia_externa: payload.referencia_externa,
    sacador: {
      cep: payload.sacadorCEP,
      documento: payload.sacadorDocumento,
      nome: payload.sacadorNome,
    },
    valor: payload.valor,
    vencimento: payload.vencimento,
  };
  const showToaster = flow(toaster.action.show, put);
  try {
    yield put(currentStore.action.fetchStart());
    const [success, result] = yield call(postApiSlipService, sendPayload);

    if (!success) {
      throw result;
    }
    yield put(currentStore.action.fetchSuccess(result));
    yield put(dialogSendSlip.action.open(result));
  } catch (e) {
    yield put(currentStore.action.fetchError());

    yield showToaster({
      message: 'Aconteceu um erro, tente novamente mais tarde',
      variant: 'error',
    });
  }
}

function* watch() {
  yield takeLatest(
    currentStore.constant.ACTION_TYPES.SERVICE.POST,
    handleServicePost
  );
}

export default {
  watch,
};
